/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface HospitalNoticePopupSimple {
  /** 병원 공지사항 팝업 고유 ID */
  _id?: string;
  /** 해당 공지사항이 작성된 순으로 1부터 시작되는 수 */
  index?: number;
  /** 해당 팝업의 이름 */
  name?: string;
  /** 해당 팝업이 노출되기 시작하는 일시 */
  startDate?: string;
  /** 해당 팝업이 노출되지 않는 종료 일시 */
  endDate?: string;
  /**
   * 노출 중단 설정 플래그
   * @default false
   */
  isPaused?: boolean;
  /** 해당 팝업이 노출되는 대상의 병원ID */
  hospitalID?: string;
  /**
   * 해당 팝업이 유저에게 노출된 횟수
   * @default 0
   */
  viewCount?: number;
  /**
   * 해당 팝업의 삭제여부 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 최초로 작성된 생성일시 */
  createdAt?: string;
  /** 마지막으로 수정된 수정일시 */
  updatedAt?: string;
}

export interface HospitalNoticePopupFilterFiles {
  /** 병원 공지사항 팝업 고유 ID */
  _id?: string;
  /** 해당 공지사항이 작성된 순으로 1부터 시작되는 수 */
  index?: number;
  /** 해당 팝업의 이름 */
  name?: string;
  /** 해당 팝업이 노출되기 시작하는 일시 */
  startDate?: string;
  /** 해당 팝업이 노출되지 않는 종료 일시 */
  endDate?: string;
  /**
   * 노출 중단 설정 플래그
   * @default false
   */
  isPaused?: boolean;
  /** 해당 팝업이 노출되는 대상의 병원ID */
  hospitalID?: string;
  /** 해당 팝업이 연결되는 HospitalNotice의 ID */
  hospitalNoticeID?: string;
  /** 해당 팝업의 타입 정의 */
  popupType?: string;
  /** 해당 팝업이 노출될 때  모바일 유저가 보게 될 팝업의 타이틀 문자열 */
  title?: string;
  /** popupType 값이 text인 경우 출력될 내용 문자열 */
  content?: string;
  /** popupType이 image 인 경우 출력될 이미지url이 포함된 File 모델 ID */
  fileIDs?: File[];
  /** 해당 팝업이 노출되어야 하는 유저의 조건. */
  filter?: {
    /** 팝업을 노출할 담당의 조건 */
    doctorID_in?: UserName[];
    /** 팝업을 노출하지 않을 담당의 조건 */
    doctorID_nin?: UserName[];
    /** 팝업을 노출할 고객태그 조건 */
    tagID_in?: UserTagName[];
    /** 팝업을 노출하지 않을 고객태그 조건 */
    tagID_nin?: UserTagName[];
    /** 팝업을 노출할 치료태그 조건 */
    treatmentCategoryID_in?: TreatmentCategoryName[];
    /** 팝업을 노출하지 않을 치료태그 조건 */
    treatmentCategoryID_nin?: TreatmentCategoryName[];
    /** 팝업을 노출할 초진/재진 조건 */
    isFirstVisit_in?: boolean[];
    /** 팝업을 노출하지 않을 초진/재진 조건 */
    isFirstVisit_nin?: boolean[];
  }[];
  /**
   * 해당 팝업을 통해 공지사항 까지 도달한 횟수
   * @default 0
   */
  clickCount?: number;
  /**
   * 해당 팝업이 유저에게 노출된 횟수
   * @default 0
   */
  viewCount?: number;
  /**
   * 해당 팝업의 삭제여부 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 최초 작성자의 User ID */
  writerID?: string;
  /** 마지막으로 수정을 시도한 사용자의 User ID */
  modifierID?: string;
  /** 최초로 작성된 생성일시 */
  createdAt?: string;
  /** 마지막으로 수정된 수정일시 */
  updatedAt?: string;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserName {
  /** User의 기본 ObjectId */
  _id?: string;
  /** 이름 */
  name?: string;
}

export interface UserTagName {
  /** 태그의 고유 ID */
  _id?: string;
  /** 작성된 태그의 이름(병원 내 Unique) */
  name?: string;
}

export interface TreatmentCategoryName {
  /** 치료 카테고리의 고유 ID */
  _id: string;
  /** 고객유형(치료유형) 명칭 */
  categoryName: string;
}

export interface HospitalNoticePopup {
  /** 병원 공지사항 팝업 고유 ID */
  _id?: string;
  /** 해당 공지사항이 작성된 순으로 1부터 시작되는 수 */
  index?: number;
  /** 해당 팝업의 이름 */
  name?: string;
  /** 해당 팝업이 노출되기 시작하는 일시 */
  startDate?: string;
  /** 해당 팝업이 노출되지 않는 종료 일시 */
  endDate?: string;
  /**
   * 노출 중단 설정 플래그
   * @default false
   */
  isPaused?: boolean;
  /** 해당 팝업이 노출되는 대상의 병원ID */
  hospitalID?: string;
  /** 해당 팝업이 연결되는 HospitalNotice의 ID */
  hospitalNoticeID?: string;
  /** 해당 팝업의 타입 정의 */
  popupType?: string;
  /** 해당 팝업이 노출될 때  모바일 유저가 보게 될 팝업의 타이틀 문자열 */
  title?: string;
  /** popupType 값이 text인 경우 출력될 내용 문자열 */
  content?: string;
  /** popupType이 image 인 경우 출력될 이미지url이 포함된 File 모델 ID */
  fileIDs?: any[];
  /** 해당 팝업이 노출되어야 하는 유저의 조건. */
  filter?: any[];
  /**
   * 해당 팝업을 통해 공지사항 까지 도달한 횟수
   * @default 0
   */
  clickCount?: number;
  /**
   * 해당 팝업이 유저에게 노출된 횟수
   * @default 0
   */
  viewCount?: number;
  /**
   * 해당 팝업의 삭제여부 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 최초 작성자의 User ID */
  writerID?: string;
  /** 마지막으로 수정을 시도한 사용자의 User ID */
  modifierID?: string;
  /** 최초로 작성된 생성일시 */
  createdAt?: string;
  /** 마지막으로 수정된 수정일시 */
  updatedAt?: string;
}

export interface ApiPopupHospitalElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (팝업 이름) */
  keyword?: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiPopupHospitalElFindSimpleData = ApiResponse & {
  data: HospitalNoticePopupSimple[];
};

export interface ApiPopupHospitalElFindDetailParams {
  /** (required) 병원 공지사항 팝업 ID */
  _id: string;
}

export type ApiPopupHospitalElFindDetailData = ApiResponse & {
  data: HospitalNoticePopupFilterFiles;
};

export interface ApiPopupHospitalElCountParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** (optional) 삭제 여부 */
  isRemoved?: boolean;
  /** (optional) 검색어 (공지사항 팝업 이름) */
  keyword?: string;
}

export type ApiPopupHospitalElCountData = ApiResponse & {
  data: number;
};

export type ApiPopupHospitalElCreateData = ApiResponse & {
  data: HospitalNoticePopup;
};

export type ApiPopupHospitalElUpdateData = ApiResponse & {
  data: HospitalNoticePopup;
};

export type ApiPopupHospitalElRemoveData = ApiResponse & {
  data: HospitalNoticePopup;
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElFindSimple
     * @summary 병원별 공지사항 팝업 목록 간단 조회
     * @request GET:/v3/api/popup/hospital/el/find/simple
     * @secure
     * @response `200` `ApiPopupHospitalElFindSimpleData` \[\{HospitalNoticePopup\}\] 선택한 HospitalID 대한 HospitalNoticePopup 컬렉션 객체 배열
     */
    apiPopupHospitalElFindSimple: (query: ApiPopupHospitalElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalElFindSimpleData, any>({
        path: `/v3/api/popup/hospital/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElFindDetail
     * @summary 병원별 공지사항 팝업 상세 조회
     * @request GET:/v3/api/popup/hospital/el/find/detail
     * @secure
     * @response `200` `ApiPopupHospitalElFindDetailData` \{HospitalNoticePopup\} HospitalNoticePopup 컬렉션 객체
     */
    apiPopupHospitalElFindDetail: (query: ApiPopupHospitalElFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalElFindDetailData, any>({
        path: `/v3/api/popup/hospital/el/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElCount
     * @summary 병원별 공지사항 팝업 목록 수 조회
     * @request GET:/v3/api/popup/hospital/el/count
     * @secure
     * @response `200` `ApiPopupHospitalElCountData` 선택한 HospitalID 대한 HospitalNoticePopup 수
     */
    apiPopupHospitalElCount: (query: ApiPopupHospitalElCountParams, params: RequestParams = {}) =>
      this.request<ApiPopupHospitalElCountData, any>({
        path: `/v3/api/popup/hospital/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElCreate
     * @summary 병원별 공지사항 팝업 생성
     * @request POST:/v3/api/popup/hospital/el/create
     * @secure
     * @response `200` `ApiPopupHospitalElCreateData` \{HospitalNoticePopup\} 생성된 병원 공지사항 팝업 객체
     */
    apiPopupHospitalElCreate: (
      data: {
        /** (required) 팝업 이름 */
        name: string;
        /**
         * (required) 팝업 기간 시작 날짜
         * @default "2023-04-10"
         */
        startDate: string;
        /**
         * (required) 팝업 기간 종료 날짜
         * @default "2023-04-16"
         */
        endDate: string;
        /** (required) 병원 ObjectId */
        hospitalID: string;
        /** (required) 병원 공지사항 ObjectId */
        hospitalNoticeID: string;
        /** (required) 팝업 종류 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        popupType: string;
        /** (optional) 텍스트 팝업일 경우, 팝업 내용 - 제목 */
        title?: string;
        /** (optional) 텍스트 팝업일 경우, 팝업 내용 - 내용 */
        content?: string;
        /** (optional) 팝업 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (required) 공지 노출 대상. 전체 노출 시, 객체 내 모든 값 빈배열 */
        filter: {
          /** 치료태그 노출 대상 */
          treatmentCategoryID_in: string[];
          /** 초,재진 여부 노출 대상. */
          isFirstVisit_in: boolean[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElCreateData, any>({
        path: `/v3/api/popup/hospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElUpdate
     * @summary 병원별 공지사항 팝업 수정
     * @request POST:/v3/api/popup/hospital/el/update
     * @secure
     * @response `200` `ApiPopupHospitalElUpdateData` \{HospitalNoticePopup\} 수정된 병원 공지사항 팝업 객체
     */
    apiPopupHospitalElUpdate: (
      data: {
        /** (required) 수정할 공지사항 팝업 ObjectId */
        _id: string;
        /** (required) 팝업 이름 */
        name: string;
        /**
         * (required) 팝업 기간 시작 날짜
         * @default "2023-04-10"
         */
        startDate: string;
        /**
         * (required) 팝업 기간 종료 날짜
         * @default "2023-04-16"
         */
        endDate: string;
        /** (required) 병원 ObjectId */
        hospitalID: string;
        /** (required) 병원 공지사항 ObjectId */
        hospitalNoticeID: string;
        /** (required) 팝업 종류 .. 텍스트 팝업 (text), 이미지 팝업 (image) */
        popupType: string;
        /** (optional) 텍스트 팝업일 경우, 팝업 내용 - 제목 */
        title?: string;
        /** (optional) 텍스트 팝업일 경우, 팝업 내용 - 내용 */
        content?: string;
        /** (optional) 팝업 상세정보 타입이 이미지 일때, 이미지 내용 */
        fileIDs?: string[];
        /** (required) 공지 노출 대상. 전체 노출 시, 객체 내 모든 값 빈배열 */
        filter: {
          /** 치료태그 노출 대상 */
          treatmentCategoryID_in: string[];
          /** 초,재진 여부 노출 대상. */
          isFirstVisit_in: boolean[];
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElUpdateData, any>({
        path: `/v3/api/popup/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNoticePopup
     * @name ApiPopupHospitalElRemove
     * @summary 병원별 공지사항 팝업 삭제
     * @request POST:/v3/api/popup/hospital/el/remove
     * @secure
     * @response `200` `ApiPopupHospitalElRemoveData` \{HospitalNoticePopup\} 삭제된 HospitalNoticePopup 객체
     */
    apiPopupHospitalElRemove: (
      data: {
        /** (required) 삭제할 공지사항 팝업 ObjectId */
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPopupHospitalElRemoveData, any>({
        path: `/v3/api/popup/hospital/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
